import clsx from 'clsx';
import Txt from 'components/atoms/Txt/Txt';
import React from 'react';
import classes from './UserBalance.module.scss';
import Currency from 'components/atoms/Currency/Currency';

interface UserBalanceProps {
  currentBalance: number;
  targetAmount: number;
  className?: string;
  difference: number;
}

export const BalanceDescription = ({
  currentBalance,
  targetAmount,
  difference,
}: UserBalanceProps) => {
  return (
    <div className={clsx(classes.amountDifference)}>
      {currentBalance >= targetAmount ? (
        <Txt component="p" className={classes.amountDifferenceText}>
          You&apos;re ready to order a reward
        </Txt>
      ) : (
        <Txt component="p" className={classes.amountDifferenceText}>
          Only{' '}
          <Txt component="span" bold skipTranslation>
            <Currency amount={difference} currency="USD" />
          </Txt>{' '}
          needed until next reward
        </Txt>
      )}
    </div>
  );
};
